import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import SearchIcon from 'public/icons/search.svg';
import Image from 'next/image';
import classNames from 'classnames/bind';
import styles from './SearchBar.module.css';
import ClearIcon from 'components/common/ClearIcon';

const cx = classNames.bind(styles);

interface ISearchBar {
  onSearch: (value: string) => void;
  defaultValue?: string;
}

function SearchBar({ onSearch, defaultValue = '' }: ISearchBar) {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    /* query params에 있던 search text 일 경우 useEffect 내에서 리렌더링 */
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSearch = (value: string) => {
    onSearch(value);
  };

  return (
    <Input
      className={cx('input-box')}
      allowClear={{
        clearIcon: <ClearIcon onClick={() => onSearch('')} />,
      }}
      placeholder="Search"
      onChange={handleChangeValue}
      onPressEnter={() => handleSearch(value)}
      value={value}
      suffix={
        <Button
          type="text"
          onClick={() => {
            handleSearch(value);
          }}
          style={{
            padding: 0,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span className={cx('search-icon')}>
            <Image
              src={SearchIcon}
              alt="Search icon"
              layout="fill"
              style={{ cursor: 'pointer' }}
            />
          </span>
        </Button>
      }
    />
  );
}

export default SearchBar;
